<script setup>
import { onMounted, ref } from 'vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

import { Button } from '@components'
import OverviewLoader from './OverviewLoader.vue'
import OverviewInformation from './OverviewInformation.vue'
import Main from '../layout/Main.vue'
import { getHashQueryParam } from '@utils'

const isOverviewLoaded = ref(false)
onMounted(async () => {
    $appointments.matchAppointmentPreRequirement()
    setTimeout(() => {
        isOverviewLoaded.value = true
    }, 500)
    $appointments.state.error = ''

    //  if payment failed and local storage has prebook_stripe_confirmation_data, remove it.
    if (localStorage.getItem('prebook_stripe_confirmation_data') && getHashQueryParam('prebook_payment') !== 'success') {
        localStorage.removeItem('prebook_stripe_confirmation_data')

        // reset appointment from cookies
        $appointments.appointment = {
            service_id: null,
            staff_id: null,
            booking_date: null,
            booking_time_start: null,
            payment_method: window.prebook.settings.payment.default_payment_method || 'cash',
            booking_time_end: null,
        }

        await $appointments.cookiesAppointment('set')

        router.push({ name: 'service' })
    }

    // If prebook_payment in cookie is 'success', goto next step.
    if (document.cookie.split(';').some((item) => item.trim().startsWith('prebook_payment='))) {
        console.log("prebook_payment in cookie is 'success'")

        const prebook_payment = document.cookie.replace(/(?:(?:^|.*;\s*)prebook_payment\s*=\s*([^;]*).*$)|^.*$/, '$1')
        if (prebook_payment === 'success') {
            $appointments.cookiesAppointment('get')
            $appointments.confirmation = $appointments.appointment

            // reset appointment from cookies
            $appointments.appointment = {
                service_id: null,
                staff_id: null,
                booking_date: null,
                booking_time_start: null,
                payment_method: window.prebook.settings.payment.default_payment_method || 'cash',
                booking_time_end: null,
            }

            $appointments.cookiesAppointment('set')

            $appointments.nextStep()

            // remove prebook_payment cookie
            document.cookie = 'prebook_payment=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        }
    }
})
</script>

<style lang="scss" scoped></style>

<template>
    <Main>
        <template #content>
            <div class="overview-page-title" :style="$customizer.titleStyle">{{ $settings.customizer.booking_overview.title || '' }}</div>

            <!-- empty Account loader -->
            <OverviewLoader v-if="!isOverviewLoaded" />

            <!-- Account list -->
            <OverviewInformation v-if="isOverviewLoaded" />
            <div class="text-[#bd4e4e] text-base font-medium mt-1 absolute" v-if="$appointments.state.error">{{ $appointments.state.error }}</div>
        </template>

        <template #footer v-if="isOverviewLoaded">
            <Button @click="$appointments.submitBookingConfirmation()" type="primary" size="md" radius="square" class="w-full" :buttonStyle="$customizer.buttonStyle">{{ $appointments.state.loading ? 'Loading...' : `Confirm ${$settings.labels.appointment?.singular}` }}</Button>
            <!-- <div class="grid grid-cols-2 gap-5">
                <Button type="secondary_gray" size="md" radius="square" class="w-full">Deposit booking</Button>
                <Button type="primary" size="md" radius="square" class="w-full">Pay now</Button>
            </div> -->
        </template>
    </Main>
</template>